export const ArrowRightIcon = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.16602 10H15.8327" stroke="#032565" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10 4.16663L15.8333 9.99996L10 15.8333" stroke="#032565" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
